export * from './src/restaurants-operations-v1-operation-operations.universal.js';
